export function validateEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

export function validatePhoneNumber(phoneNumber: string): boolean {
    const regex = /^[0-9]{0,10}$/;
    return regex.test(phoneNumber) && phoneNumber.length === 10;
}
